import { wespeechcraftmobile, queryMediaId } from "@/server/api.js";
import { handleShowMore,shareListFun } from '@/utils/public';
import { Toast } from "vant";
import Pdfh5 from "pdfh5";
import "pdfh5/css/pdfh5.css";

export default {
    // 组件名必写
    name: "TreeChild",
    props: {
        // 总数据，必传
        datalist: Array,
        titleval:String
    },
    data() {
        return {
            // 当前级组件已展开的项
            expandArr: [],
            treeList: [],
            activeNames: "",
            pageNum: 1,
            mediaid: "",
            showMore: false,
            showHeight: 50,
            expandTrue: false,
            showPdf: false,
            showFile: false,
            showType: '',
            preFileUrl: '',
            detailObj: {},
        };
    },
    watch:{
        titleval(){
            this.activeNames = '';
        }
    },
    methods: {
        // 展开
        async expandItem(id) {
            this.treeList = [];
            if(this.activeNames==id){
                this.activeNames = '';
                return false;
            }
            this.activeNames = id;
            if (id) {
                const res = await wespeechcraftmobile({
                    groupId: id,
                    pageSize: 1000,
                    type:0,
                    title:this.titleval
                });
                this.treeList = res.data.t;
                this.treeList.map((v) => {
                    if (v.listAtt.length > 3) {
                        this.expandTrue = false;
                        v.listtotal = v.listAtt.length;
                        v.newlistArr = v.listAtt.slice(0, 3);
                    } else {
                        v.newlistArr = v.listAtt;
                    }
                });
                this.isShowExpand();
            }
        },
        isShowExpand() {
            this.$nextTick(() => {
                let hideText = document.querySelectorAll(".textMsgType>p");
                for (let i of hideText) {
                    if (i.offsetHeight > 89) {
                        i.nextElementSibling.style.display = "block";
                        i.classList.add("hide-text");
                    }
                }
            });
        },
        loadImg(e){
           e.target.style.opacity = '1';
        },

        fahterexpandItem(val) {
            this.expandItem(this.activeNames, val);
        },
        lookMore(obj) {
            this.expandTrue = true;
            obj.newlistArr = obj.listAtt;
            this.$forceUpdate();
        },
        closeList(obj) {
            this.expandTrue = false;
            obj.newlistArr = obj.newlistArr.slice(0, 3);
            this.$forceUpdate();
        },
        async getMediaId(id) {
            const res = await queryMediaId({ id: id });
            if (res.code !== "200") return Toast.fail(res.msg);
            this.mediaid = { mediaid: res.data };
        },
        //点击展开更多
        handleShowMoreClick(){
            return handleShowMore;
        },
        //分享话术列表
        async shareList(obj){
            await shareListFun(obj)
        },
        // shareImgVideo() {
        //     this.shareList(this.detailObj)
        // },
        // 预览
        previewFile(e, obj) {
            e.stopPropagation();
            this.detailObj = obj
            this.showType = obj.msgType;
            this[obj.msgType =='file'?'showPdf':'showFile'] = true
            this.preFileUrl = obj.url;
            if(obj.msgType === 'file' ){
                this.$nextTick(() => {
                    if (this.pdfh5) {
                        this.pdfh5.destroy()
                        this.pdfh5 = null
                      }
                    this.pdfh5 = new Pdfh5("#pdf-detail", {
                        pdfurl: obj.url,
                        maxZoom: 3,
                        lazy: true,
                        scrollEnable: true,
                    })
                });
            }
        },
        closePopup() {
            this.showPdf = false;
            this.detailObj = {}
        },
        closeImg() {
            this.showFile = false;
            this.preFileUrl = ''
            this.detailObj = {}
        }
    },
};
